import edit_tracking from './edit_tracking'
import endDate from '../end_date'

export default {
  edit_tracking,
  edit_end_date: endDate,
  create_basics: endDate,
}
